(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acu-home-community"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('acu-quotes')) {
  customElements.define('acu-quotes', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.acu-quotes__track');
      this.slides = Array.from(this.querySelectorAll('[data-quote]'));
      if (!this.track || this.slides.length < 2) return;
      this.current = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.visible = false;
      this.timer = null;
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelector('.acu-quotes__controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => {this.pause(); this.go(this.current - 1);}, {signal});
      this.querySelector('[data-next]').addEventListener('click', () => {this.pause(); this.go(this.current + 1);}, {signal});
      this.toggle?.addEventListener('click', () => {this.paused = !this.paused; this.update(); this.schedule();}, {signal});
      this.addEventListener('pointerenter', (event) => {if (event.pointerType === 'mouse') {this.hovered = true; this.clear();}}, {signal});
      this.addEventListener('pointerleave', () => {this.hovered = false; this.schedule();}, {signal});
      this.addEventListener('focusin', () => this.pause(), {signal});
      this.track.addEventListener('pointerdown', () => this.pause(), {signal});
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.pause(); this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.current = this.slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - this.track.scrollLeft) < Math.abs(this.slides[best].offsetLeft - this.track.scrollLeft) ? index : best, 0);
          this.update(); this.schedule();
        }, 130);
      }, {signal, passive: true});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.reduced.addEventListener('change', () => {if (this.reduced.matches) this.pause();}, {signal});
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) {this.pause(); this.go(index);}
      }, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting; this.schedule();
      }, {threshold: 0.35});
      this.observer.observe(this);
      let width = this.track.clientWidth;
      this.resizeObserver = new ResizeObserver(() => {
        if (this.track.clientWidth !== width) {
          width = this.track.clientWidth;
          this.track.scrollTo({left: this.slides[this.current].offsetLeft, behavior: 'instant'});
        }
      });
      this.resizeObserver.observe(this.track);
      this.update();
    }
    clear() {clearTimeout(this.timer); this.timer = null;}
    pause() {this.paused = true; this.clear(); this.update();}
    update() {
      this.querySelector('[data-current]').textContent = String(this.current + 1);
      this.track.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.current)));
      if (this.toggle) {
        this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }
    }
    go(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({left: this.slides[this.current].offsetLeft, behavior: this.reduced.matches ? 'instant' : 'smooth'});
      this.update(); this.schedule();
    }
    schedule() {
      this.clear();
      if (this.paused || this.hovered || !this.visible || document.hidden) return;
      const words = this.slides[this.current].textContent.trim().split(/\s+/).length;
      const delay = Math.max(Number(this.dataset.interval) || 12000, words * 320 + 2000);
      this.timer = setTimeout(() => this.go(this.current + 1), delay);
    }
    disconnectedCallback() {
      this.clear(); clearTimeout(this.scrollTimer);
      this.observer?.disconnect(); this.resizeObserver?.disconnect();
      this.controller?.abort(); this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
